/* stylelint-disable selector-class-pattern */

sew-ws-stage-item {
    --stage-image-animation-time: 5000ms;

    display: block;
    position: relative;

    &::after,
    &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
    }

    &:not(:has(.compact)) {
        &::after {
            background: linear-gradient(
                to right,
                rgba(0, 0, 0, 0.6),
                rgba(0, 0, 0, 0) 50%,
                transparent 0,
                transparent
            );
        }
    }
    &::before {
        background: linear-gradient(
            to bottom,
            rgba(0, 0, 0, 0.9),
            rgba(0, 0, 0, 0) 30%,
            transparent 0,
            transparent
        );
    }

    .image-wrapper,
    .video-wrapper {
        overflow: hidden;
        max-height: min(80vh, 1000px);
        min-height: 600px;
        display: flex;
        flex-direction: column;
    }

    .video-wrapper {
        position: relative;
        height: 50vw;
        z-index: 2;
    }

    sew-picture {
        display: block;
        transform: scale(1);
        transition: transform var(--stage-image-animation-time) linear;
        width: 100%;
    }

    sew-video {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 2;
    }

    &[autoplay] {
        sew-video {
            z-index: 0;
        }
    }

    .stage-teaser {
        background-color: $color-white;
        box-sizing: border-box;
        color: $color-grey-01-dark;
        max-width: 634px;
        padding: clamp(24px, 2.778vw, 40px) clamp(24px, 3.472vw, 50px) 32px clamp(24px, 5.556vw, 80px);
        position: absolute;
        transform: translateY(-50%);
        bottom: 0;
        width: 44vw;
        z-index: 1000;
        opacity: 0.95;

        &::after {
            background-color: $color-red;
            bottom: -6px;
            content: '';
            height: 6px;
            left: 0;
            position: absolute;
            transform: scaleX(0);
            transform-origin: left;
            width: 100%;
        }

        @keyframes loading {
            from {
                transform: scaleX(0);
            }
            to {
                transform: scaleX(1);
            }
        }
    }

    .compact {
        background-color: transparent;
    }

    .topic-line {
        @include typo-ws-topic-line-stage;
    }

    .headline {
        @include font-h1;

        margin-top: 4px;
        min-height: clamp(88px, 5.9vw, 112px);
        hyphens: auto;
        text-wrap: balance;
    }

    .link {
        color: $color-red;
        display: inline-block;
        margin-top: 8px;
        position: relative;
        transform: translate3d(-9px, 0, 0);
        transition: transform 0.2s;

        .svg {
            left: -2px;
            position: absolute;
            top: 2px;
        }

        .shaft {
            opacity: 0;
            transition: opacity 0.2s;
        }

        a {
            @include typo-ws-h4;

            color: inherit;
            padding-left: 28px;
            text-decoration: none;
        }

        &:hover {
            transform: translate3d(0, 0, 0);

            .shaft {
                opacity: 1;
            }
        }
    }

    &.is-active {
        z-index: 1;

        sew-picture {
            transform: scale(1.3);
        }

        .stage-teaser {
            &::after {
                animation: loading var(--stage-image-animation-time) linear;
            }
        }
    }

    .slotted {
        margin-top: 24px;

        div {
            display: flex;
            flex-direction: row;
            column-gap: 10px;
        }
    }
}

@include mq-4-min {
    sew-ws-stage-item {
        .stage-teaser {
            left: 50%;
            // half max content width, see _grid.scss
            transform: translate3d(-880px, -50%, 0);
        }

        .compact {
            padding-left: 0;
        }
    }
}

@include mq-3 {
    sew-ws-stage-item {
        .stage-teaser {
            left: 0;
        }
    }
}

@include mq-2 {
    sew-ws-stage-item {
        .stage-teaser {
            width: 50vw;
        }

        .image-wrapper,
        .video-wrapper {
            min-height: 500px;
        }
    }
}

@include mq-1 {
    sew-ws-stage-item {
        padding-bottom: 270px;

        &::after {
            display: none;
        }

        .image-wrapper,
        .video-wrapper {
            aspect-ratio: 1;
            max-height: unset;
            min-height: unset;
        }

        .video-wrapper {
            height: unset;
        }

        sew-picture {
            width: 100%;
            height: 100%;
        }

        .stage-teaser {
            opacity: 1;
            bottom: 108px;
            left: var(--grid-margin);
            top: auto;
            transform: translateY(0);
            width: calc(100% - var(--grid-margin) - var(--grid-margin));
            max-width: none;
        }
    }
}
